import { useEffect } from 'react';
import {
  useDismissHealthCheck,
  useHealthChecks,
} from '../../../../api/integration-health-client/integration-health-client.hooks';
import { BrandedLoadingOverlay } from '../../../../components/loader/branded-loader';
import { useOrganizationId } from '../../../../helpers/auth-helpers/auth.hooks';
import { useDataManagementStore } from '../../../../store/data-management-store/data-management-store';
import { Tab } from '../../../../store/data-management-store/data-management-store.type';
import { useToast } from '../../../notifications/notifications.hooks';
import { IntegrationHealthTab } from './integration-health-tab';

/**
 * Container for the Integration Health tab. Owns data fetching and the dismiss
 * mutation so the presentational component stays stateless and duplicate POSTs
 * are blocked via isPending.
 */
export function IntegrationHealthTabContainer() {
  const organizationId = useOrganizationId();
  const activeTab = useDataManagementStore((state) => state.activeTab);
  const toast = useToast();

  const { data: issues = [], query } = useHealthChecks(organizationId ?? '', {
    enabled: !!organizationId && activeTab === Tab.IntegrationHealthChecker,
  });

  const { mutate: dismiss, isPending: isDismissing } = useDismissHealthCheck();

  useEffect(() => {
    if (query.isError) {
      toast.showError('Failed to load integration health checks. Please try again.');
    }
  }, [query.isError, toast]);

  return (
    <>
      <BrandedLoadingOverlay visible={query.isFetching} />
      {!query.isFetching && (
        <IntegrationHealthTab issues={issues} onDismiss={(issueId) => dismiss(issueId)} isDismissing={isDismissing} />
      )}
    </>
  );
}
